import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { errorHandler } from "../../../util/errorHandler";
import { isNull } from "../../../util/check";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import GoBack from "../../../component/molecules/goBack";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import MainInput from "../../../component/atoms/input/mainInput";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import Modal from "../../../component/templates/Modal";
import { modalMsg } from "../../../util/modalMsg";
import styled from "styled-components";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import Checkbox from "../../../component/atoms/input/checkbox";
import MemberApi from "../../../api/memebr.api";
import Radio from "../../../component/atoms/input/radio";
import DateInput from "../../../component/atoms/input/dateInput";
import moment from "moment";
import { regExpression } from "../../../util/regExpresstion";

const CommonMemberEdit = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  const [memberInfo, setMemberInfo] = useState({
    nicknameChangeFlag: false,
    nickname: "",
    name: "",
    birth: "",
    email: "",
    marketingAgreement: true,
    adAgreement: true,
    smsAgreement: true,
    membership: false,
    activation: true,
  });

  useEffect(() => {
    getMemberInfo();
  }, []);

  const getMemberInfo = async () => {
    try {
      const response = (await MemberApi.getById(id)).data.data.content;
      setMemberInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // --------------------------------------------- //
  // ----------------- 저장하기 ----------------- //
  // ------------------------------------------- //
  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveBtnHandler = () => {
    if (isNull(memberInfo.nickname)) {
      return toast("닉네임을 입력해주세요");
    }

    if (isNull(memberInfo.name)) {
      return toast("이름을 입력해주세요");
    }

    if (isNull(memberInfo.birth)) {
      return toast("생년월일을 입력해주세요");
    }

    if (isNull(memberInfo.email)) {
      return toast("이메일을 입력해주세요");
    }

    if (!regExpression.email.test(memberInfo.email.trim())) {
      return toast("올바른 이메일 형식을 입력해주세요");
    }

    setSaveModalOpen(true);
  };

  const saveFunc = async () => {
    try {
      const data = {
        nicknameChangeFlag: memberInfo.nicknameChangeFlag,
        nickname: memberInfo.nickname,
        name: memberInfo.name,
        birth: memberInfo.birth,
        email: memberInfo.email.trim(),
        marketingAgreement: memberInfo.marketingAgreement,
        adAgreement: memberInfo.adAgreement,
        smsAgreement: memberInfo.smsAgreement,
        membership: memberInfo.membership,
        activation: memberInfo.activation,
      };
      await MemberApi.editMember(id, data);

      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.update);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />

      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>최종 접속 시간</DetailFormTitle>
                <DetailFormText>
                  {memberInfo.lastLoginDate
                    ? moment(memberInfo.lastLoginDate).format(
                        "YYYY/MM/DD HH:mm:ss"
                      )
                    : ""}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>유형</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"false"}
                    name={"type"}
                    valueText={"일반회원"}
                    checked={!memberInfo.membership}
                    onChange={() => {
                      setMemberInfo((prevInfo) => ({
                        ...prevInfo,
                        membership: false,
                      }));
                    }}
                  />
                  <Radio
                    id={"true"}
                    name={"type"}
                    valueText={"구독회원"}
                    checked={memberInfo.membership}
                    onChange={() => {
                      setMemberInfo((prevInfo) => ({
                        ...prevInfo,
                        membership: true,
                      }));
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>계정 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"true"}
                    name={"activation"}
                    valueText={"활성"}
                    checked={memberInfo.activation}
                    onChange={() => {
                      setMemberInfo((prevInfo) => ({
                        ...prevInfo,
                        activation: true,
                      }));
                    }}
                  />
                  <Radio
                    id={"false"}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!memberInfo.activation}
                    onChange={() => {
                      setMemberInfo((prevInfo) => ({
                        ...prevInfo,
                        activation: false,
                      }));
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>가입일</DetailFormTitle>
                <DetailFormText>
                  {moment(memberInfo.createdAt).format("YYYY/MM/DD")}
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>아이디</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  value={memberInfo.account}
                  disabled={true}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>닉네임</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"닉네임을 입력해주세요"}
                  value={memberInfo.nickname}
                  onChange={(e) => {
                    setMemberInfo((prevInfo) => ({
                      ...prevInfo,
                      nicknameChangeFlag: true,
                      nickname: e.target.value,
                    }));
                  }}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이름</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  value={memberInfo.name}
                  disabled
                />
              </DetailPageForm>

              <DetailPageForm>
                <DetailFormTitle>전화번호</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"전화번호를 입력해주세요"}
                  value={memberInfo.phoneNumber}
                  disabled={true}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>생년월일</DetailFormTitle>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <MainInput
                    style={{
                      width: 338,
                    }}
                    type={"text"}
                    value={memberInfo.birth}
                    disabled
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이메일</DetailFormTitle>
                <MainInput
                  style={{
                    width: 338,
                  }}
                  type={"text"}
                  placeholder={"이메일을 입력해주세요"}
                  value={memberInfo.email}
                  onChange={(e) => {
                    setMemberInfo((prevInfo) => ({
                      ...prevInfo,
                      email: e.target.value,
                    }));
                  }}
                />
              </DetailPageForm>

              {/* 약관 동의 */}
              <DetailPageForm
                style={{
                  alignItems: "flex-start",
                }}
              >
                <DetailFormTitle>약관 동의</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <CheckboxWrapper>
                    <DetailFormText>만 14세 이상입니다 (필수)</DetailFormText>
                    <Checkbox id="agreement" checked={true} disabled={true} />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>회원이용약관 (필수)</DetailFormText>
                    <Checkbox id="privacy" checked={true} disabled={true} />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>
                      개인정보 수집 및 이용동의 (필수)
                    </DetailFormText>
                    <Checkbox id="privacy" checked={true} disabled={true} />
                  </CheckboxWrapper>
                </div>
              </DetailPageForm>

              {/* 알림 수신 동의 */}
              <DetailPageForm
                style={{
                  alignItems: "flex-start",
                }}
              >
                <DetailFormTitle>알림 수신 동의</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <CheckboxWrapper>
                    <DetailFormText>
                      이메일 및 SMS 마케팅정보수신 동의 (선택)
                    </DetailFormText>
                    <Checkbox
                      id="marketingInfo"
                      checked={memberInfo.marketingAgreement}
                      onChange={() => {
                        setMemberInfo({
                          ...memberInfo,
                          marketingAgreement: !memberInfo.marketingAgreement,
                        });
                      }}
                    />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>
                      광고성 정보 수신 동의 (선택)
                    </DetailFormText>
                    <Checkbox
                      id="marketingInfo"
                      checked={memberInfo.adAgreement}
                      onChange={() => {
                        setMemberInfo({
                          ...memberInfo,
                          adAgreement: !memberInfo.adAgreement,
                        });
                      }}
                    />
                  </CheckboxWrapper>
                  <CheckboxWrapper>
                    <DetailFormText>SMS 수신 동의 (선택)</DetailFormText>
                    <Checkbox
                      id="marketingInfo"
                      checked={memberInfo.smsAgreement}
                      onChange={() => {
                        setMemberInfo({
                          ...memberInfo,
                          smsAgreement: !memberInfo.smsAgreement,
                        });
                      }}
                    />
                  </CheckboxWrapper>
                </div>
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  saveBtnHandler();
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            saveFunc();
          }}
        />
      ) : null}
    </>
  );
};

export default CommonMemberEdit;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 338px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 15px;
  border-radius: 4px;
  border: 1px solid #adb4ba;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 338px;
  min-height: 356px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 4px 20px 0px rgba(10, 13, 20, 0.15);
  position: absolute;
  top: 50px;
  right: 0;
  padding: 10px;
  overflow-y: auto;
  z-index: 5;
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: "flex";
  justify-content: "space-between";
  align-items: "center";
  width: "318px";
  height: "42px";
  padding: "10px";
  cursor: "pointer";
  border-radius: 3px;

  &:hover {
    background-color: #f2f4f5;
  }
`;
